module.exports = __webpack_public_path__ + "static/img/wechat.0d0a8e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/wechat.png
// module id = zClx
// module chunks = 0